export default __webpack_public_path__ + "static/media/20.b9b4bfeb.jpg";